import { useMemo } from 'react'
import isObject from 'lodash/isObject'
import { useSWRWithCache } from '@purecarslabs/signal-core/swr/hooks'
import { GenericFetchHookParamsType } from '@purecarslabs/signal-core/contextFetch/types'
import { fetchData, fetchDataNull } from '@purecarslabs/signal-core/swr/fetch'
import { FetchHandlerType } from '@purecarslabs/signal-core/swr/types'
import { getAPIDomain } from '@purecarslabs/signal-utils/env/apiDomain'
/* webpack-strip-block:removed */
import { MvhColorsType } from '@app-src/types'
import { MakeBrandType } from './types'

export interface UseAccountMakeBrandType extends GenericFetchHookParamsType {
  accountId: string
  mvhColors?: MvhColorsType | null
}

// this function returns a path to the API call made by useAccountMakeBrand
export function getAccountMakeBrand(accountId: string): string {
  return `${getAPIDomain('/branding/api')}/v1/make-brand/account/${accountId}`
}

/**
 * this is a wrapper around useSWRWithCache that can be used to fetch the lead form spec
 * @return {UseAccountMakeBrandType | undefined} - undefined until fetch completes, then the make brand data
 */
export function useAccountMakeBrand({
  accountId,
  mvhColors,
  ...rest
}: UseAccountMakeBrandType): MakeBrandType | undefined {
  const url = useMemo(() => getAccountMakeBrand(accountId), [accountId])
  return (
    useSWRWithCache({
      context: 'useAccountMakeBrand',
      fetchHandler: (accountId && !isObject(mvhColors) && mvhColors !== null
        ? fetchData
        : fetchDataNull) as FetchHandlerType<MakeBrandType>,
      transformFunc: (makeBrandRaw: unknown): MakeBrandType | undefined =>
        (makeBrandRaw instanceof Response ? {} : makeBrandRaw) as MakeBrandType,
      url,
      /* webpack-strip-block:removed */
      ...rest
      // eslint-disable-next-line prettier/prettier
    })
    /* webpack-strip-block:removed */
  )
}
